import React from 'react';
import styled from 'styled-components';

import { GetCardTypeForBody } from '../../../../../../../util/utils';
import AresSpecialBodyContainer from '../../AresSpecialBodyContainer';
import ControlProperties from './ControlProperties';

export default function ControlPropertiesBody(props) {
	const {
		bodyContent,
		headerId,
		sectionId,
		bodyId,
		updateBodyOptions,
		getBodiesBySectionId,
		isSnapshotView,
		documentId,
		...extraProps
	} = props;

	const formBodyBorder = GetCardTypeForBody(bodyContent);

	return (
		<Wrapper className={`SectionBodyWrapper ControlProperties ${formBodyBorder}`}>
			<AresSpecialBodyContainer
				bodyContent={bodyContent}
				headerId={headerId}
				sectionId={sectionId}
				bodyId={bodyId}
				updateBodyOptions={updateBodyOptions}
				getBodiesBySectionId={getBodiesBySectionId}
				isSnapshotView={isSnapshotView}
				showDescription={false}
				{...extraProps}
			>
				<ControlProperties bodyId={bodyId}/>
			</AresSpecialBodyContainer>
		</Wrapper>
	);
}

const Wrapper = styled.section`
	display: block;
`;
